import { styled, Divider } from '@mui/material';

const StyledOverviewProfileDivider = styled(Divider)(() => ({
  marginBottom: '22px'
}));

export default StyledOverviewProfileDivider;
